/**
 * Joins class names, dropping falsy values.
 *
 * Components use this to compose their BEM base class with modifiers and with
 * any layout utilities a page passes down via `className`.
 */
type ClassValue = string | number | bigint | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values
    .filter((value): value is string => typeof value === 'string' && value !== '')
    .join(' ');
}
